export type GlobalSearchResultType = 'item' | 'recipe';

export interface GlobalSearchResult {
  id: string;
  type: GlobalSearchResultType;
  title: string;
  subtitle: string;
  path: string;
}

export interface GlobalSearchItem {
  id: string;
  name: string;
  sku: string;
  category?: string;
}

export interface GlobalSearchRecipe {
  id: string;
  name: string;
  sku: string;
  components?: unknown[];
}

const RESULT_LIMIT = 8;

export function mapGlobalSearchResults(
  items: GlobalSearchItem[],
  recipes: GlobalSearchRecipe[],
): GlobalSearchResult[] {
  const mapped: GlobalSearchResult[] = [
    ...items.map((item) => ({
      id: item.id,
      type: 'item' as const,
      title: item.name,
      subtitle: `SKU: ${item.sku}${item.category ? ` · ${item.category}` : ''}`,
      path: `/inventory/${item.id}`,
    })),
    ...recipes.map((recipe) => ({
      id: recipe.id,
      type: 'recipe' as const,
      title: recipe.name,
      subtitle: `SKU: ${recipe.sku}${recipe.components ? ` · ${recipe.components.length} components` : ''}`,
      path: `/recipes/${recipe.id}`,
    })),
  ];

  return mapped.slice(0, RESULT_LIMIT);
}
